import type { VoidFunctionComponent } from 'react';

import { BannerStyle } from '../../../../../../typings/enums';
import Banner from '../../../../generic/Banner';

type Props = {
  title: string;
  body: string;
  onDismiss: () => void;
};

const ErrorBanner: VoidFunctionComponent<Props> = ({ title, body, onDismiss }) => {
  return (
    <Banner
      bannerStyle={BannerStyle.High}
      title={title}
      body={body}
      isDismissible
      onDismiss={onDismiss}
    />
  );
};

export default ErrorBanner;
